import React, { useEffect, useRef, useState } from "react";
import EvaluationCard from "./EvaluationCard";
import { evaluatedOutcome, SHOW_CRITERION_EVENT, scrollToWhenReady } from "./evaluationRules";

// `filterable` (the phone report): 47 cards are ~10 screens, and what a trainee acts on is
// what they missed — so it opens on 보완 필요, with 충족 and 전체 a tap away.
const FILTERS = [
  ["missed", "보완 필요", (o) => o && !o.favorable],
  ["met", "충족", (o) => o && o.favorable],
  ["all", "전체", () => true],
];

const EvaluatedCriteria = ({ evaluatedcriterion_set, filterable = false }) => {
  const criterionRef = useRef(null);
  const [filter, setFilter] = useState("missed");

  // The summary's 평가 기준 chips link to a card that the filter may be hiding.
  useEffect(() => {
    if (!filterable) return undefined;
    const show = (e) => {
      setFilter("all");
      scrollToWhenReady(`criterion_int_id_${e.detail}`);
    };
    window.addEventListener(SHOW_CRITERION_EVENT, show);
    return () => window.removeEventListener(SHOW_CRITERION_EVENT, show);
  }, [filterable]);

  const counts = Object.fromEntries(
    FILTERS.map(([key, , test]) => [key, evaluatedcriterion_set.filter((c) => test(evaluatedOutcome(c))).length])
  );
  const test = FILTERS.find(([key]) => key === filter)[2];
  const shown = filterable
    ? evaluatedcriterion_set.filter((c) => test(evaluatedOutcome(c)))
    : evaluatedcriterion_set;

  return (
    <>
      {filterable && (
        <div style={{ display: "flex", gap: "8px", margin: "8px 0 4px", flexWrap: "wrap" }}>
          {FILTERS.map(([key, label]) => (
            <button
              key={key}
              type="button"
              onClick={() => setFilter(key)}
              style={{
                border: "none",
                borderRadius: "999px",
                padding: "6px 12px",
                fontSize: "13px",
                fontWeight: 600,
                backgroundColor: filter === key ? "#1d1d1f" : "#F2F2F7",
                color: filter === key ? "white" : "#424245",
              }}
            >
              {label} {counts[key]}
            </button>
          ))}
        </div>
      )}
      <div ref={criterionRef} style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: filterable ? "4px" : 0 }}>
        {shown.map((evaluatedcriterion) => (
          // The id is what 평가 기준 chips in the summary scroll to.
          <div key={evaluatedcriterion.criterion.int_id} id={`criterion_int_id_${evaluatedcriterion.criterion.int_id}`}>
            <EvaluationCard evaluatedcriterion={evaluatedcriterion} />
          </div>
        ))}
      </div>
    </>
  );
};

export default EvaluatedCriteria;
